/**
 * Shop pages reachable through the /s/:pageSlug share link.
 *
 * The slug is interpolated straight into a redirect path, so this list is an
 * allow-list rather than a convention: without it, /s/:pageSlug could be used
 * to point a recipient at any path under /<role>/shop/.
 */
export const SHARED_SHOP_PAGES = ['fresh-summit'];

export const isSharedShopPage = (pageSlug) =>
  SHARED_SHOP_PAGES.includes(pageSlug);
